import React from 'react';
import { Progress } from 'antd';
import useSafeUseProgress from '@src/components/hooks/useSafeProgress';
import styles from '../../../../pages/user/studio.module.css';
import { S3_IMAGES_URL } from 'util/constants';

export const CustomLoader = () => {
  const { safeActive: active, safeProgress: progress } = useSafeUseProgress();

  return (
    <>
      <div
        className={`${styles.containerGeneral} ${
          active ? styles.active : styles.hidden
        }`}
      >
        <img
          src={`${S3_IMAGES_URL}/assets/logos/ozoneStudioLogo.png`}
          className={styles.spin}
          alt='spin'
        />
        <div className={`${styles.containerLoader} ${styles.progress}`}>
          <Progress percent={progress} showInfo={false} />
        </div>
        <p className={styles.percentage}>Loading {Math.trunc(progress)} %</p>
      </div>
    </>
  );
};
